import { useCallback, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { enqueueErrorSnackbar } from '../../../actions/Notifications';
import { updateWizardStep, setCurrentStep } from '../wizardSlice';

export const useWizardNavigation = ({
  currentShop,
  wizardType,
  currentStep,
  currentStepIndex,
  isLastStep,
  complete,
  onComplete,
  goNextInternal,
}) => {
  const dispatch = useDispatch();
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const prevSavingRef = useRef(false);

  const navigateNext = useCallback((savedStepIndex, savedIsLastStep) => {
    if (savedIsLastStep) {
      complete();
      if (onComplete) onComplete();
    } else {
      dispatch(setCurrentStep(currentShop, wizardType, savedStepIndex + 1));
    }
  }, [complete, onComplete, dispatch, currentShop, wizardType]);

  const saveAndNavigate = useCallback((stepData) => {
    const stepIdToSave = currentStep?.id;
    const savedStepIndex = currentStepIndex;
    const savedIsLastStep = isLastStep;

    const navigationAction = () => {
      navigateNext(savedStepIndex, savedIsLastStep);
    };

    setPendingNavigation(() => navigationAction);
    dispatch(
      updateWizardStep(currentShop, wizardType, stepIdToSave, savedStepIndex, stepData),
    );
  }, [currentStep, currentStepIndex, isLastStep, dispatch, currentShop, wizardType, navigateNext]);

  const handleSaveCompletion = useCallback((saving, error) => {
    if (prevSavingRef.current && !saving && pendingNavigation) {
      if (error) {
        dispatch(enqueueErrorSnackbar(error));
        setPendingNavigation(null);
      } else {
        const action = pendingNavigation;
        setPendingNavigation(null);
        action();
      }
    }
    prevSavingRef.current = saving;
  }, [pendingNavigation, dispatch]);

  return {
    saveAndNavigate,
    handleSaveCompletion,
    navigateNext: () => {
      if (isLastStep) {
        complete();
        if (onComplete) onComplete();
      } else {
        goNextInternal();
      }
    },
  };
};
